import { api_GET, api_PUT,api_POSTFile, api_POST } from "api/_axios.js";

const dre_api =
{
    get: function (custcode_id, mesano) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`dre/${custcode_id}/${mesano}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getExport: function (indicadorDREFiltro) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`dre/GetExport/`, indicadorDREFiltro).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getIndicador: function (indicadorDREFiltro) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`dre/GetIndicador/`, indicadorDREFiltro).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    put: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`dre`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getCsvTemplateImport: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`dre/modeloCsvImport`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    postImportCsv: function (usuarioId,grupoEconomico,formData) {
        const promise = new Promise((resolve, reject) => {
            api_POSTFile(`dre/uploadCSVDreManutencao/${usuarioId}/${encodeURIComponent(grupoEconomico)}`, formData).then(result => {
                resolve(result)
            });
        });
        return promise;
    },

    putReceitasAdicionais: function (model) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`dre/receitas-adicionais`, model).then(result => {
                resolve(result)
            });
        });
        return promise;
    }

}

export default dre_api
